export const FAVORITES_SERVICE = "FavoritesService";
